module.exports = __webpack_public_path__ + "static/media/reports.497b8aa0.svg";